import moment from 'moment';
import 'moment/locale/pt';
import 'moment/locale/sr';

import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import Icon from '../../../../components/icon';
import {Column, Row} from '../../../../components/layout';
import colors from '../../../../util/colors';
import {Icons} from '../../../../util/icons';
import {ReimbursementItem} from '../interfaces';
import ReimbursementListItemStatus from './ReimbursementListItemStatus';
import ReimbursementSubmissionStatusBar from '../../components/ReimbursementSubmissionStatusBar';
import * as fonts from '../../../../util/fonts';
import {formatCurrencyExpenses} from '../../../../util/utility';

export interface ReimbursementListItemProps {
  reimbursementItem: ReimbursementItem;
  statuses: {
    value: string;
    label: string;
    statedId: string;
    colorCode: string;
  }[];
  ReimbursementFinishedSubmitting(values?: any): void;
  buStyles: any;
  language: string;
  userLanguage: string;
}

function ReimbursementListItem(props: ReimbursementListItemProps) {
  let statusId = props.reimbursementItem.stateId?.toLowerCase();
  let currentStatus = props.statuses.find((e) => e.value === statusId);
  let color = currentStatus?.colorCode;
  let stateDescription = currentStatus?.label;

  const defineLang = () => {
    const dateLanguage =
      (props.language || props.userLanguage)?.split('-')[0] === 'rs'
        ? 'sr'
        : (props.language || props.userLanguage)?.split('-')[0];
    return dateLanguage;
  };

  return (
    <>
      <Row className="homepage-margin-bottom">
        {parseInt(props.reimbursementItem.stateId, 10) >= 102 &&
        parseInt(props.reimbursementItem.stateId, 10) <= 104 ? (
          <>
            <Column className="reimbursement-history-declarationlist-column1-loading">
              <strong
                style={{
                  color:
                    props.reimbursementItem.stateId === '103'
                      ? colors.alertRed
                      : colors.black,
                }}>
                {props.reimbursementItem.state}
              </strong>
            </Column>
            <Column className="reimbursement-history-declarationlist-column2-loading">
              {props.reimbursementItem.stateId === '103' ? (
                <Icon
                  width="20"
                  height="20"
                  color={colors.alertRed}
                  name={Icons.ALERT_PROBLEM}
                  changeViewbox={false}
                />
              ) : (
                <ReimbursementSubmissionStatusBar
                  sessionId={props.reimbursementItem.sessionId}
                  ReimbursementFinishedSubmitting={() =>
                    props.ReimbursementFinishedSubmitting(
                      props.reimbursementItem.sessionId,
                    )
                  }
                />
              )}
            </Column>
          </>
        ) : (
          <>
            <Column
              className="reimbursement-history-declarationlist-column1"
              style={{...fonts.MM}}>
              <strong className="reimbursement-history-item-date">
                {props.reimbursementItem.stateId === '101'
                  ? props.reimbursementItem.metadata.docDate
                    ? moment(props.reimbursementItem.metadata.docDate)
                        .locale(defineLang())
                        .format('DD MMM')
                        .toUpperCase()
                    : '--'
                  : props.reimbursementItem.dosFrom
                    ? moment(props.reimbursementItem.dosFrom)
                        .locale(defineLang())
                        .format('DD MMM')
                        .toUpperCase()
                    : '--'}
              </strong>
              <div className="reimbursement-history-item-date-year">
                {props.reimbursementItem.stateId === '101'
                  ? props.reimbursementItem.metadata.docDate
                    ? new Date(
                        props.reimbursementItem.metadata.docDate,
                      ).getFullYear()
                    : null
                  : props.reimbursementItem.dosFrom
                    ? new Date(props.reimbursementItem.dosFrom).getFullYear()
                    : null}
              </div>
            </Column>
            <Column className="reimbursement-history-declarationlist-column2">
              <strong
                className="reimbursement-history-declarationlist-column2-spec"
                style={{
                  ...fonts.MM,
                  ...fonts.Bold,
                  color: props.buStyles?.primaryColor || colors.blue,
                }}>
                {props.reimbursementItem.catName ||
                  (props.reimbursementItem.metadata &&
                    props.reimbursementItem.metadata.atoMedicos &&
                    props.reimbursementItem.metadata.atoMedicos[0] &&
                    props.reimbursementItem.metadata.atoMedicos[0]
                      .coberturaDescription) ||
                  '-'}
              </strong>
              {props.reimbursementItem.clinicName || '-'}
            </Column>
            <Column className="reimbursement-history-declarationlist-audit-number">
              <span style={{color: colors.darkGrey}}>
                {props.reimbursementItem.auditNbr}
              </span>
            </Column>
            <Column
              className={
                props.reimbursementItem.amountPaid !== 0
                  ? 'reimbursement-history-declarationlist-column3-price'
                  : 'reimbursement-history-declarationlist-column3'
              }>
              <Row className="reimbursement-list-item-status-row">
                <ReimbursementListItemStatus
                  color={color}
                  stateDescription={stateDescription}
                />
              </Row>
              <Row className="reimbursement-list-item-price-row">
                {props.reimbursementItem.amountPaid !== 0 ? (
                  <strong>
                    {formatCurrencyExpenses(
                      props.reimbursementItem.amountPaid,
                      props.reimbursementItem.currency,
                    )}
                  </strong>
                ) : (
                  <></>
                )}
              </Row>
            </Column>
          </>
        )}
      </Row>
      <div className="reimbursement-history-declarationlist-line" />
    </>
  );
}

const mapStateToProps = ({globalStyles, language, user}: any) => ({
  buStyles: globalStyles.value,
  language: language.value,
  userLanguage: user.value.language,
});

export default compose(connect(mapStateToProps)(ReimbursementListItem));
